import { markIconSvg } from "./markSvgs";

export type IconKey = "EAC" | "CE" | "CLASS_I" | "CLASS_II" | "CLASS_III";

/** Vector marks from assets/mark (1–3 = safety classes, CE, EAC); logical 100×100 proportions. */
export function iconToSvg(icon: IconKey, w: number, h: number, fill: string) {
  switch (icon) {
    case "EAC":
      return markIconSvg("EAC", w, h, fill);
    case "CE":
      return markIconSvg("CE", w, h, fill);
    case "CLASS_I":
      return markIconSvg("1", w, h, fill);
    case "CLASS_II":
      return markIconSvg("2", w, h, fill);
    case "CLASS_III":
      return markIconSvg("3", w, h, fill);
  }
}
